import { render, staticRenderFns } from "./createMasterProvider.vue?vue&type=template&id=a25f4ad6&"
import script from "./createMasterProvider.vue?vue&type=script&lang=js&"
export * from "./createMasterProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports